import { Currency } from '@sequencehq/api'
import { useInvoicesGridCsvExport } from 'components/Invoices/InvoicesGrid/useInvoicesGridCsvExport'
import { FC, useState } from 'react'
import {
  DateRangePickerField,
  SwitchLineInput,
  SimpleModal,
  Flex
} from '@sequencehq/core-components'

type DownloadInvoicesGridCsvExportModalProps = {
  currency: Currency
  onClose: () => void
}

export const DownloadInvoicesGridCsvExportModal: FC<
  DownloadInvoicesGridCsvExportModalProps
> = ({ currency, onClose }) => {
  const { download } = useInvoicesGridCsvExport()
  const [showDates, setShowDates] = useState<boolean>(true)
  const [dates, setDates] = useState<[Date, Date] | undefined>(undefined)

  const handleDownload = () => {
    if (download.available && currency) {
      download.onClick(
        currency,
        showDates ? dates?.[0] : undefined,
        showDates ? dates?.[1] : undefined
      )
      return true
    }
    return false
  }

  return (
    <SimpleModal
      isOpen
      onClose={onClose}
      data-testid="invoices.gridCsvExportModal"
      title="Download CSV export"
      cancelButtonText="Cancel"
      submitButtonText="Download"
      onSubmit={handleDownload}
      minHeight="136px"
      submitDisabled={!download.available || !currency}
    >
      <Flex flexDirection="column" gap="16px">
        <DateRangePickerField
          value={dates}
          label="Select export date range"
          onChange={setDates}
          isDisabled={!showDates}
        />
        <SwitchLineInput
          text="Export everything"
          value={!showDates}
          onChange={() => setShowDates(prev => !prev)}
        ></SwitchLineInput>
      </Flex>
    </SimpleModal>
  )
}
